// Stepper numerico con incremento/decremento e input manuale
import { Plus, Minus } from 'lucide-react';

export function NumericStepper({ value, onChange, min = 1, max = 999, disabled = false, testId = 'stepper' }) {
  const handleDecrement = () => {
    if (value > min) onChange(value - 1);
  };

  const handleIncrement = () => {
    if (value < max) onChange(value + 1);
  };

  return (
    <div className="flex items-center border border-zinc-200 rounded-lg bg-white overflow-hidden h-10" data-testid={`numeric-${testId}`}>
      <button
        type="button"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        className="w-10 h-full flex items-center justify-center text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid={`${testId}-decrement`}
      >
        <Minus className="h-4 w-4" />
      </button>
      <input
        type="number"
        value={value}
        onChange={(e) => {
          const val = parseInt(e.target.value) || min;
          onChange(Math.max(min, Math.min(max, val)));
        }}
        disabled={disabled}
        className="w-14 h-full text-center font-mono font-medium text-sm border-x border-zinc-200 focus:outline-none focus:ring-1 focus:ring-zinc-900 disabled:opacity-50"
        data-testid={`${testId}-input`}
      />
      <button
        type="button"
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        className="w-10 h-full flex items-center justify-center text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid={`${testId}-increment`}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
